import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import IllustrationUsageHistory from '../../../domain/entities/IllustrationUsageHistory';

export default function reducer(
  state: {[key: number]: IllustrationUsageHistory} = {},
  action: AnyAction,
): {[key: number]: IllustrationUsageHistory} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexIllustrationUsageHistoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: IllustrationUsageHistory},
            record: IllustrationUsageHistory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.UpdateIllustrationUsageHistorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
